module.exports = __webpack_public_path__ + "static/media/eye.36a77225.svg";